export const THROTTLE_INTERVAL = 1000;
